import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/part/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsNCFileEventsStack = createStackNavigator();

const PartDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <PartDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <PartDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </PartDetailsNCFileEventsStack.Navigator>
  );
};

export { PartDetailsNCFileEventsNavigator };
